import { FormControl, InputLabel, MenuItem, Select, SxProps } from '@mui/material';
import ExternalSchoolTag from './ExternalSchoolTag';
import './SelectDropdown.css';

type FormControlSize = 'small' | 'medium';

interface SelectDropdownProps {
  label: string;
  selectedValue: string;
  handleChange: (event: any) => void;
  handleDelete?: () => void;
  items: {
    label: string;
    value: string;
  }[];
  containerClasses?: string[];
  formControlClasses?: string[];
  isClearable?: boolean;
  size?: FormControlSize;
  selectSxProps?: SxProps;
  fullWidth?: boolean;
  formControlVariant?: 'standard' | 'outlined' | 'filled';
  externalSchools?: Set<string>;
}

function SelectDropdown({
  label,
  selectedValue,
  handleChange,
  handleDelete,
  items,
  containerClasses,
  formControlClasses,
  isClearable = true,
  size,
  selectSxProps,
  fullWidth = true,
  formControlVariant = 'standard',
  externalSchools,
}: SelectDropdownProps) {
  const containerClassNames = containerClasses?.join(' ') ?? '';
  const formControlClassNames = formControlClasses?.join(' ') ?? '';

  const isExternal = (itemLabel: string) => externalSchools?.has(itemLabel) ?? false;

  return (
    <div className={`${containerClassNames}`} data-testid="form-control-container">
      <FormControl
        variant={formControlVariant}
        className={`${formControlClassNames} select`}
        size={size}
        data-testid="form-control"
        fullWidth={fullWidth}
        sx={{ minWidth: '200px' }}
      >
        <InputLabel id="select-label">{label}</InputLabel>
        <Select
          sx={selectSxProps}
          labelId="select-label"
          label={label}
          value={selectedValue}
          onChange={handleChange}
          renderValue={(value) => items.find((item) => item.value === value)?.label ?? value}
        >
          {items?.map((item, index) => (
            <MenuItem key={index} value={item.value}>
              <span className="select-dropdown-item">
                {item.label}
                {isExternal(item.label) && (
                  <ExternalSchoolTag variant="ext" showTooltip={false} isInteractive={false} />
                )}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default SelectDropdown;
